import { useState, useRef, useContext } from 'react';
import { Button, Container, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/Drivers/DriverSetting/DriverProfileSetting.css';
import defaultProfilePic from '../../../assets/images/profilepic.png';
import DriverSettingsMasterLayout from '../../../layouts/Drivers/DriverSettingsMasterLayout';
import axios from "axios";
import AppContext from "../../../context/AppContext";

const DriverProfileSetting = () => {
  const navigate = useNavigate();
  const { baseUrl, authToken } = useContext(AppContext);
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    userName: '',
    mobileNumber: '',
    email: ''
  });

  const [profileImage, setProfileImage] = useState(defaultProfilePic);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setProfileImage(reader.result);
        };
        reader.readAsDataURL(file);
      } else {
        alert('Please select an image file');
      }
    }
  };

  const handleUpdate = (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append('drivername', formData.userName);
    data.append('driverphone', formData.mobileNumber);
    data.append('driverEmail', formData.email);
    if (fileInputRef.current.files[0]) {
      data.append('driver_image', fileInputRef.current.files[0]);
    }

    axios.post(`${baseUrl}/driver/profile/updateProfile`, data, {
      headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${authToken}` }
    }).then((response) => {
      if (response.data.success === true) {
        alert('Profile updated!');
        navigate('/driver-setting');
      }
    }).catch(() => alert("Network Error!"));
  };

  return (
    <DriverSettingsMasterLayout screenName={"Profile Settings"} centered={true}>
      <div className="driver-profile-setting-container">
        <Container className="driver-profile-setting-content">
          <div className="driver-profile-setting-image-wrapper">
            <img
              src={profileImage}
              className="driver-profile-setting-image"
              alt="Profile"
            />
            <div
              className="driver-profile-setting-edit-badge"
              onClick={handleImageClick}
            >
              <span>✏️</span>
            </div>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleImageChange}
              accept="image/*"
              style={{ display: 'none' }}
            />
          </div>

          <Form onSubmit={handleUpdate} className="driver-profile-setting-form">
            <Form.Group className="driver-profile-setting-form-group">
              <Form.Label className="driver-profile-setting-label">User Name</Form.Label>
              <Form.Control
                type="text"
                name="userName"
                placeholder="Enter your name"
                value={formData.userName}
                onChange={handleChange}
                required
                className="driver-profile-setting-input"
              />
            </Form.Group>

            <Form.Group className="driver-profile-setting-form-group">
              <Form.Label className="driver-profile-setting-label">Mobile Number</Form.Label>
              <Form.Control
                type="tel"
                name="mobileNumber"
                placeholder="Enter your number"
                value={formData.mobileNumber}
                onChange={handleChange}
                required
                className="driver-profile-setting-input"
              />
            </Form.Group>

            <Form.Group className="driver-profile-setting-form-group">
              <Form.Label className="driver-profile-setting-label">Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
                className="driver-profile-setting-input"
              />
            </Form.Group>

            <Button
              type="submit"
              className="driver-profile-setting-update-btn"
            >
              Update
            </Button>
          </Form>
        </Container>
      </div>
    </DriverSettingsMasterLayout>
  );
};

export default DriverProfileSetting;